import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { PLACEHOLDER_MOVIE_POSTER } from "@config/ImageSizes";
import { ApplicationContext } from "@context/ApplicationContext";
import { SearchContext } from "@context/SearchContext";
import SearchSelect from "@components/SearchSelect";
import Loader from "@components/Ui/Loader";
import SearchLens from "@components/V3/Icons/SearchLens";
import "./style.scss";

const SearchBar = () => {
    const history = useHistory();

    const {
        fetchSearchOptions,
        isSearchOptionsLoading,
        searchOptions,
    } = useContext(SearchContext);

    const [activeSearchItem, setActiveSearchItem] = useState(null);

    const { cdnUrl } = useContext(ApplicationContext);
    const fallbackPoster = `${cdnUrl}${PLACEHOLDER_MOVIE_POSTER}`;

    const handleFocus = () => {
        document.body.classList.add("select-focused");
    };

    const handleBlur = () => {
        document.body.classList.remove("select-focused");
    };

    const handleOnChangeSearch = (option, { action }) => {
        if (action === "clear") {
            setActiveSearchItem(null);
        } else if (action === "select-option") {
            setActiveSearchItem(option);
            if (option?.url) {
                history.push(option.url);
            }
        }
    };


    const filterOptions = (candidate, input) => {
        const candidateStr = candidate.value.toLowerCase();
        const candidateTerms = candidateStr.split(" ");
        const searchStr = input.toLowerCase();

        return searchStr && searchStr.includes(" ")
            ? candidateStr.includes(searchStr)
            : searchStr
                ? candidateTerms.some((str) => str.startsWith(searchStr))
                : false;
    };

    const customNoOptionsMessage = () => (
        <>
            {(isSearchOptionsLoading) ? (
                <Loader isLoading={isSearchOptionsLoading} text="Searching" />
            ) : (
                <span className="search-bar__no-results">
                    We did not find any results
                </span>
            )}
        </>
    );

    const CustomOption = (props) => {
        const { data, innerRef, innerProps, isFocused, isSelected } = props;

        return (
            <div
                className={`search-bar__link dropdown-item react-select__option ${isFocused ? "react-select__option--is-focused" : ""}`}
                ref={innerRef}
                id={innerProps.id}
                onMouseMove={innerProps.onMouseMove}
                onMouseOver={innerProps.onMouseOver}
                onClick={innerProps.onClick}
                onTouchStart={innerProps.onTouchStart}
                onTouchMove={innerProps.onTouchMove}
                onFocus={innerProps.onFocus}
                role="option"
                aria-selected={isSelected}
                tabIndex={-1}
            >
                {data.type === "movie" ? (
                    <div className="search-bar__item">
                        <div className="search-bar__image-wrapper">
                            <img src={data.image_url || fallbackPoster} className="search-bar__image" alt={data.name} />
                        </div>
                        <div className="search-bar__text-wrapper">
                            <div className="search-bar__title">{data.name}</div>
                            <div className="search-bar__text">{data.info_description}</div>
                        </div>
                    </div>
                ) : (
                    <div className="search-bar__item--cinema">
                        <div className="search-bar__title">{data.name}</div>
                        <div className="search-bar__text">{data.venue_description}</div>
                    </div>
                )}
            </div>
        );
    };


    return (
        <div className="search-bar">
            <div className="search-bar__container">
                <span className="search-bar__icon">
                    <SearchLens className="svg-icon" />
                </span>
                <SearchSelect
                    className="search-bar"
                    placeholder="type in a movie or cinema"
                    aria-label="Select a search input"
                    options={searchOptions}
                    filterOption={filterOptions}
                    onChange={handleOnChangeSearch}
                    onInputChange={(inputValue) => {
                        if (searchOptions.length === 0 && !isSearchOptionsLoading) {
                            fetchSearchOptions();
                        }
                    }}
                    blurInputOnSelect={true}
                    closeMenuOnSelect={true}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    isClearable={true}
                    components={{
                        Option: CustomOption,
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                    }}
                    openMenuOnClick={false}
                    noOptionsMessage={customNoOptionsMessage}
                    value={setActiveSearchItem}
                />
            </div>
        </div>
    );
};

export default SearchBar;
